import { IRectangleCoordinatable, instanceOfIRectangleCoordinatable } from "../../../../base/domain/drawing";
import { IEditableFormatObject, instanceOfEditableFormatObject } from "../IEditableFormatStructure";
import { ElementTypes } from "./ElementTypes";

export interface IRectangleCoordinatableObject extends IEditableFormatObject, IRectangleCoordinatable {}

export function instanceOfIRectangleCoordinatableObject<T extends IRectangleCoordinatableObject>(instance: any, type: ElementTypes): instance is IRectangleCoordinatableObject {
  return instance
      && instanceOfIRectangleCoordinatable(instance)
      && instanceOfEditableFormatObject<T>(instance, type);
}
